import { render, staticRenderFns } from "./FacilityMain.vue?vue&type=template&id=20133d03&"
import script from "./FacilityMain.vue?vue&type=script&lang=js&"
export * from "./FacilityMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20133d03')) {
      api.createRecord('20133d03', component.options)
    } else {
      api.reload('20133d03', component.options)
    }
    module.hot.accept("./FacilityMain.vue?vue&type=template&id=20133d03&", function () {
      api.rerender('20133d03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Organizers/Facility/FacilityMain.vue"
export default component.exports